import React, { PropsWithChildren, useLayoutEffect } from 'react';
import { GameScreens } from '~/modules/Elements/GameScreens';
import Toolbar from '~/modules/Toolbar/Toolbar';

interface Props extends PropsWithChildren {
  toolbar?: boolean;
  toolbarContent?: React.ReactNode;

  /**
   * game: UI del juego (puede usar NormalizeFontSize)
   * web: menús/pantallas normales (NO deben encogerse)
   */
  uiMode?: 'game' | 'web';
}

function LayoutGame({ children, toolbarContent, toolbar = true, uiMode = 'game' }: Props) {
  useLayoutEffect(() => {
    const html = document.documentElement;
    const prev = html.dataset.uiMode;

    html.dataset.uiMode = uiMode;

    return () => {
      if (prev) html.dataset.uiMode = prev;
      else delete html.dataset.uiMode;
    };
  }, [uiMode]);

  return (
    <GameScreens>
      {toolbar && <Toolbar>{toolbarContent}</Toolbar>}
      {children}
    </GameScreens>
  );
}

export default LayoutGame;
